document.addEventListener('DOMContentLoaded', function() {
    let bannerBlocks = document.querySelectorAll('.banner .banner-block');
    bannerBlocks.forEach(function(block) {
        block.classList.add('active');
    });

    //non-breaking-space in the title
    function updateSpace() {
        const element = document.querySelector('.js-non-breaking-space');
        if (window.innerWidth <= 767) {
            element.innerHTML = element.innerHTML.replace(/&nbsp;/g, ' ');
        }
    }

    window.addEventListener('resize', updateSpace);
    updateSpace();
});